import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SignatureInputModalComponent} from './signature-input-modal.component';
import {BaseModalModule} from '@paperlessio/sdk/modal/base-modal';
import {FormsModule} from '@angular/forms';
import {TranslocoModule} from '@ngneat/transloco';
import {SignaturePadModule} from '@shared/controls/signature-pad/signature-pad.module';
import {TabsModule} from '@shared/controls/tabs/tabs.module';
import {FilePickerModule} from '@shared/controls/file-picker/file-picker.module';

@NgModule({
  declarations: [SignatureInputModalComponent],
  imports: [
    CommonModule,
    BaseModalModule,
    SignaturePadModule,
    FormsModule,
    TranslocoModule,
    TabsModule,
    FilePickerModule
  ]
})
export class SignatureInputModalModule {}
